import React from 'react';
import Helmet from 'react-helmet';
import { graphql } from 'gatsby';
import { MDXRenderer } from 'gatsby-plugin-mdx';

import Layout from '../components/Layout';
import Link from '../components/Link';
import { relativeToAbsUrl } from '../utils/urls';
import { GLOSSARY_URL, useGlossaryArray } from '../utils/glossary';
import { GlossaryNav } from '../components/Glossary/GlossaryNav';
import PageHead from '../components/Head/PageHead';

export default ({ data, location, path }) => {
  const glossaryData = useGlossaryArray({ pages: data.glossaryFiles.nodes });
  const page = data.mdx || {};
  const title =
    page.headings && page.headings[0] ? page.headings[0].value : 'Docs';
  const url = relativeToAbsUrl(path);
  return (
    <React.Fragment>
      <PageHead
        // canonicalUrl={url}
        meta={{
          title,
        }}
      />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify([
            {
              '@context': 'https://schema.org/',
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: 'Kubernetes Glossary',
                  item: GLOSSARY_URL,
                },
                {
                  '@type': 'ListItem',
                  position: 2,
                  name: title,
                  item: url,
                },
              ],
            },
            {
              '@context': 'http://schema.org/',
              '@type': 'DefinedTerm',
              '@id': url,
              name: title,
              termCode: title,
              inDefinedTermSet: GLOSSARY_URL,
              description: page.description,
            },
          ])}
        </script>
      </Helmet>
      <Layout location={location}>
        <div className="glossary-page">
          <Link to="/learn/kubernetes-glossary">‹ Back to Glossary</Link>
          <GlossaryNav glossaryData={glossaryData} />
          <MDXRenderer slug={page.fields.slug}>{page.body}</MDXRenderer>
        </div>
      </Layout>
    </React.Fragment>
  );
};

export const query = graphql`
  query($originalSlug: String!) {
    mdx(fields: { slug: { eq: $originalSlug } }) {
      body
      fields {
        slug
      }
      description: excerpt(pruneLength: 150, truncate: true)
      headings(depth: h1) {
        value
      }
      parent {
        ... on File {
          relativePath
        }
      }
    }
    glossaryFiles: allFile(
      filter: {
        sourceInstanceName: { eq: "glossary" }
        childMdx: { fields: { slug: { ne: null } } }
      }
    ) {
      nodes {
        page: childMdx {
          fields {
            slug
          }
          headings(depth: h1) {
            value
          }
        }
      }
    }
  }
`;
